import React from "react";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import moment from "moment-timezone";
import { CardHeader, withStyles } from "@material-ui/core";

const styles = theme => ({
  clipCard: {
    width: "100%",
    fontSize: "0.5rem"
  },
  headerContent: {
    width: `calc(100% - 40px)`
  },
  headerTitle: {
    fontSize: "1rem",
    fontWeight: "500",
    overflowX: "scroll",
    whiteSpace: "nowrap",
    "&::-webkit-scrollbar": {
      /* Chrome */
      display: "none"
    },
    "-ms-overflow-style": "none" /* IE and Edge */,
    "scrollbar-width": "none" /* Firefox */
  },
  headerSubtitle: {
    fontSize: "0.75rem",
    fontWeight: "300",
    overflowX: "scroll",
    whiteSpace: "nowrap",
    "&::-webkit-scrollbar": {
      /* Chrome */
      display: "none"
    },
    "-ms-overflow-style": "none" /* IE and Edge */,
    "scrollbar-width": "none" /* Firefox */
  },
  headerAction: {
    marginTop: 0
  }
});

class ImageClip extends React.Component {
  render() {
    const { video, classes } = this.props;
    const ClipActions = this.props.actionsComponent;
    return (
      <Card className={classes.clipCard}>
        <CardHeader
          action={<ClipActions item={video} />}
          title={video.title}
          subheader={
            video.createdAt
              ? moment(video.createdAt.split("[")[0]).format("MM-DD-YYYY")
              : video.userName
          }
          classes={{
            title: classes.headerTitle,
            subheader: classes.headerSubtitle,
            content: classes.headerContent,
            action: classes.headerAction
          }}
        />
        <CardMedia
          component="img"
          preload="metadata"
          src={
            video.thumbnailUri ||
            "https://img.mlbstatic.com/mlb-photos/image/upload/ar_16:9,g_auto,q_auto:good,w_640,c_fill,f_jpg/fastball/default_fastball_image.jpg"
          }
          style={{ height: "200px", backgroundColor: "black" }}
        />
      </Card>
    );
  }
}

export default withStyles(styles)(ImageClip);



// WEBPACK FOOTER //
// ./src/components/ImageClip.js